/**
 * Resolves when `https://rechner.covomo.de/api/v1/apps` globals are available.
 * Prefers `__covomoAppsBootstrapPromise` so a warm sessionStorage cache cannot
 * short-circuit before the network refresh replaces a stale/partial map.
 */
export function waitForAppsBootstrap(): Promise<void> {
  if (typeof window === "undefined") {
    return Promise.resolve();
  }

  const w = window as Window & {
    __covomoAppsBootstrapPromise?: Promise<unknown>;
    covomoCalculatorsMappingToEn?: Record<string, string>;
  };

  if (w.__covomoAppsBootstrapPromise) {
    return w.__covomoAppsBootstrapPromise.then(() => undefined);
  }

  if (w.covomoCalculatorsMappingToEn || w.rechnerCustomConfig) {
    return Promise.resolve();
  }

  return new Promise((resolve) => {
    const deadline = Date.now() + 10_000;
    const tick = () => {
      if (w.__covomoAppsBootstrapPromise) {
        void w.__covomoAppsBootstrapPromise.then(() => resolve());
        return;
      }
      if (
        w.covomoCalculatorsMappingToEn ||
        w.rechnerCustomConfig ||
        Date.now() > deadline
      ) {
        resolve();
        return;
      }
      requestAnimationFrame(tick);
    };
    tick();
  });
}
